<template>
  <base-section
    title="ギャラリー"
    subtitle="落ち着いた空間で、プロフェッショナルなサロンワークを"
    background="white"
  >
    <div class="gallery-container">
      <swiper
        :modules="modules"
        :slides-per-view="1"
        :space-between="20"
        :loop="true"
        :autoplay="{
          delay: 3000,
          disableOnInteraction: false,
        }"
        :pagination="{
          clickable: true,
        }"
        :navigation="true"
        :breakpoints="{
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        }"
        class="gallery-swiper"
      >
        <swiper-slide v-for="image in galleryImages" :key="image.id">
          <div class="gallery-item" @click="openLightbox(image)">
            <img :src="image.src" :alt="image.alt" />
            <div class="gallery-item__overlay">
              <i class="fas fa-search-plus"></i>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    
    <!-- Lightbox Modal -->
    <base-modal
      v-model="lightboxOpen"
      :title="currentImage?.alt || 'ギャラリー'"
      size="large"
    >
      <div class="lightbox-content">
        <img :src="currentImage?.src" :alt="currentImage?.alt" />
      </div>
    </base-modal>
  </base-section>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Pagination, Navigation } from 'swiper';
import BaseSection from '@/components/common/BaseSection.vue';
import BaseModal from '@/components/common/BaseModal.vue';

export default {
  name: 'GallerySection',
  components: {
    Swiper,
    SwiperSlide,
    BaseSection,
    BaseModal
  },
  data() {
    return {
      modules: [Autoplay, Pagination, Navigation],
      lightboxOpen: false,
      currentImage: null,
      galleryImages: [
        { id: 1, src: require('@/assets/img/gallery/1.jpg'), alt: 'サロン内観1' },
        { id: 2, src: require('@/assets/img/gallery/2.jpg'), alt: 'サロン内観2' },
        { id: 3, src: require('@/assets/img/gallery/3.jpg'), alt: 'サロン内観3' },
        { id: 4, src: require('@/assets/img/gallery/4.jpg'), alt: 'サロン内観4' },
        { id: 5, src: require('@/assets/img/gallery/5.jpg'), alt: 'サロン内観5' },
        { id: 6, src: require('@/assets/img/gallery/6.jpg'), alt: 'サロン内観6' },
        { id: 7, src: require('@/assets/img/gallery/7.jpg'), alt: 'サロン内観7' },
        { id: 8, src: require('@/assets/img/gallery/8.jpg'), alt: 'サロン内観8' },
        { id: 9, src: require('@/assets/img/gallery/9.jpg'), alt: 'サロン内観9' }
      ]
    };
  },
  methods: {
    openLightbox(image) {
      this.currentImage = image;
      this.lightboxOpen = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.gallery-container {
  max-width: 1200px;
  margin: 0 auto;
}

.gallery-swiper {
  padding-bottom: $spacing-2xl;
  
  :deep(.swiper-pagination) {
    bottom: 0;
    
    .swiper-pagination-bullet {
      background-color: $primary-light;
      opacity: 0.5;
      transition: all $transition-fast;
      
      &-active {
        background-color: $primary-color;
        opacity: 1;
      }
    }
  }
  
  :deep(.swiper-button-prev),
  :deep(.swiper-button-next) {
    color: $primary-color;
    background-color: rgba($white, 0.9);
    width: 40px;
    height: 40px;
    border-radius: $radius-full;
    box-shadow: $shadow-md;
    
    &::after {
      font-size: $font-size-md;
    }
    
    &:hover {
      background-color: $white;
      box-shadow: $shadow-lg;
    }
  }
}

.gallery-item {
  position: relative;
  @include aspect-ratio(4, 3);
  border-radius: $radius-lg;
  overflow: hidden;
  cursor: pointer;
  box-shadow: $shadow-md;
  transition: all $transition-base;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: $shadow-lg;
    
    img {
      transform: scale(1.05);
    }
    
    .gallery-item__overlay {
      opacity: 1;
    }
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform $transition-slow;
  }
  
  &__overlay {
    @include overlay(rgba($black, 0.7));
    @include flex-center;
    opacity: 0;
    transition: opacity $transition-base;
    color: $white;
    font-size: $font-size-2xl;
  }
}

.lightbox-content {
  text-align: center;
  
  img {
    max-width: 100%;
    height: auto;
    border-radius: $radius-md;
  }
}</style>